// List for stores v3 v4 will change extra free and UPGRADE TO V5 (GMV)
export const GENERAL_NOTIFY_PRICE_CHANGE_STORES = [
  'bc-dev-v2-irene02.myshopify.com',
  'bc-dev-v2-josie01.myshopify.com',
  'bc-dev-v2-irene19.myshopify.com',
  'bc-dev-v2-quinn04.myshopify.com',
  'bc-dev-v2-irene23.myshopify.com',
  'bc-dev-v2-irene24.myshopify.com',
  'bc-dev-v2-irene26.myshopify.com',
  'd358vu-t5.myshopify.com',
  'nps-shoes-usa.myshopify.com',
  'biw6gu-zf.myshopify.com',
  'ridge-ca.myshopify.com',
  'l-objetin.myshopify.com',
  '105hq2-nk.myshopify.com',
  '1d890d-2.myshopify.com',
  'b2b-kinto-uk.myshopify.com',
  'f281be-80.myshopify.com',
  'dev-paulaschoice-vietnam.myshopify.com',
  '7r0khr-nc.myshopify.com',
  'ridge-australia.myshopify.com',
  'aatu-shop.myshopify.com',
  '26a2f6-2.myshopify.com',
  'paspaley-wholesale.myshopify.com',
  'bariatricpal-wholesale-store.myshopify.com',
  'shopcapsulenyc2.myshopify.com',
  'cuddleco.myshopify.com',
  'sanitasskincare.myshopify.com',
  'vapeurs-de-liberte.myshopify.com',
  'ulsterweavers.myshopify.com',
  'gallery-excellence.myshopify.com',
  'rubadubltd.myshopify.com',
  'chelseatruckco.myshopify.com',
  'tool-bazaar.myshopify.com',
  'crockers-paint-wallpaper.myshopify.com',
  'material-good-new-website-2021.myshopify.com',
  'dillydally-2.myshopify.com',
  'wildfashion-ro.myshopify.com',
  'tch-hardware-canada.myshopify.com',
  'cartec-italia.myshopify.com',
  'tch-hardware-us.myshopify.com',
  'eleo-express.myshopify.com',
  'bambinista.myshopify.com',
  'watch-pilot.myshopify.com',
  'tailored-athlete-usa.myshopify.com',
  'catherine-tough.myshopify.com',
  'senshugroupcom.myshopify.com',
  'lifesupplyusa.myshopify.com',
  'jemiremi.myshopify.com',
  'dominion94.myshopify.com',
  'yumetenbo.myshopify.com',
  'speakerpoint-uk.myshopify.com',
  'cutedutch.myshopify.com',
  '096c41-2.myshopify.com',
  'sigagroothandel.myshopify.com',
  'petitsleep.myshopify.com',
  'heyhappiness.myshopify.com',
  'southern-cross-safety-workwear.myshopify.com',
  'bad-design-aarhus.myshopify.com',
  'masaicshop.myshopify.com',
  'union-tokyo-since2018.myshopify.com',
  'fxr-retail-fl.myshopify.com',
  'fxr-racing-ca.myshopify.com',
  'fxr-racing-com.myshopify.com',
  'thehambledon.myshopify.com',
  'bella-bridesmaids-shop.myshopify.com',
  'creatisto.myshopify.com',
  'sellier-knightsbridge.myshopify.com',
  'alex-camille.myshopify.com',
  'healthy-options-online.myshopify.com',
  'verve-wine-sf.myshopify.com',
  'headwear-24.myshopify.com',
  'peter-murphy-electrical.myshopify.com',
  'pittman-traffic-uk.myshopify.com',
  'leogifts.myshopify.com',
  'riequip-nz.myshopify.com',
  'jason-9852.myshopify.com',
  'odsdesignerclothing.myshopify.com',
  'foy-company.myshopify.com',
  'labelzonenew.myshopify.com',
  'splish-splash-swimwear.myshopify.com',
  'masterpiece-by-h-f.myshopify.com',
  'lords-and-labradors.myshopify.com',
  'wild-west-hardware.myshopify.com',
  'susan-shaw-jewelry.myshopify.com',
  'clove-technology.myshopify.com',
  'ta-to-com.myshopify.com',
  'direct-4-pets.myshopify.com',
  'bandccamera.myshopify.com',
  'galvin-for-men.myshopify.com',
  'rocks-ie.myshopify.com',
  'teppana-uk.myshopify.com',
  'sander-and-west.myshopify.com',
  'pure-direct-usa.myshopify.com',
  'poli-trading-company.myshopify.com',
  'bundarra.myshopify.com',
  'dyraland.myshopify.com',
  'curvy-iceland.myshopify.com',
  'allcarenz.myshopify.com',
  'demon-powersports.myshopify.com',
  'baseball-park-stand-in.myshopify.com',
  'youcha-online-shop.myshopify.com',
  'goodfoodproject.myshopify.com',
  'co-mac.myshopify.com',
  'b2b-kinto-europe.myshopify.com',
  'run4itonline.myshopify.com',
  'shashionline.myshopify.com',
  'cherie-amour-intimates.myshopify.com',
  'ottalaus-inc.myshopify.com',
  'three-of-something.myshopify.com',
  'metalfx.myshopify.com',
  'greenacres-ecommerce.myshopify.com',
  'orka-ca.myshopify.com',
  'top-tier-padel.myshopify.com',
  'nba-middle-east.myshopify.com',
  'lobjet-dev.myshopify.com',
  'sandiegohat.myshopify.com',
  'miss-kiss-negozio.myshopify.com',
  'evolution-ireland.myshopify.com',
  'fitzgerald-ireland.myshopify.com',
  'collectors-massapequa.myshopify.com',
  'doublewoot.myshopify.com',
  'flower-explosion.myshopify.com',
  'super-butcher.myshopify.com',
  'bulbheadstore2.myshopify.com',
  'polypet-sg.myshopify.com',
  'lambert-design-us.myshopify.com',
  'pureatlanta-com.myshopify.com',
  'artpress-publishing-ltd.myshopify.com',
  'warehouse-furniture-clearance.myshopify.com',
  'plantur-39-au.myshopify.com',
  'jackie-oo-kids-store.myshopify.com',
  'vanbeek.myshopify.com',
  'turquoise-moose.myshopify.com',
  'bornbabyatl.myshopify.com',
  'copenhagen-muse.myshopify.com',
  'worldtonetheatrical.myshopify.com',
  'vavipro.myshopify.com',
  'kristin-chase.myshopify.com',
  'nail-superstore.myshopify.com',
  'katydidcollection.myshopify.com',
  'depeche-eng-eur.myshopify.com',
  'elliot-rhodes-ltd.myshopify.com',
  'martys-meals.myshopify.com',
  'car-pretty.myshopify.com',
  '6ix-ice.myshopify.com',
  'thread-logic-store.myshopify.com',
  'twinbirdjp.myshopify.com',
  'vvog-chambly.myshopify.com',
  'mw-home.myshopify.com',
  'fogarty-wines.myshopify.com',
  'onefinesecret.myshopify.com',
  'vvog.myshopify.com',
  'charcoal-online.myshopify.com',
  'tissuspapi.myshopify.com',
  'escentials-my-production.myshopify.com',
  'cattreeking.myshopify.com',
  'schwartzvonhalen.myshopify.com',
  '32275d-2.myshopify.com',
  'titleyandco.myshopify.com',
  'schwartz-vonhalen-germany.myshopify.com',
  'tsuburaya-store.myshopify.com',
  'verkauf-bochum-de.myshopify.com',
  'trend-house-dk.myshopify.com',
  'zapclothinguk.myshopify.com',
  'schwartzvonhalen-france.myshopify.com',
  'georgerichards-storefront.myshopify.com',
  'mrbigandtall-storefront.myshopify.com',
  'schwartzvonhalen-uk.myshopify.com',
  'wethepeopleholsters-com.myshopify.com',
  'e58cb6.myshopify.com',
  'retrogression.myshopify.com',
  'the-tennis-golf-company.myshopify.com',
  'pussyfootwholesale.myshopify.com',
  'timelesscomfort.myshopify.com',
  'sea-to-summit-eu.myshopify.com',
  'the-homeware-outlet.myshopify.com',
  'skatewarehouse-co-uk.myshopify.com',
  'pool-bank-interiors.myshopify.com',
  'miller-gallery-charleston.myshopify.com',
  'playmackay.myshopify.com',
  'dunlopcanada.myshopify.com',
  'dts-westloop.myshopify.com',
  'sorens-house.myshopify.com',
  'lighthousebyron.myshopify.com',
  'penelope-47.myshopify.com',
  'last-chance-nashville.myshopify.com',
  'mid-century-mobler-berkeley.myshopify.com',
  'moon-bridge-jp.myshopify.com',
  'manipurijapan.myshopify.com',
  'northern-lights-music.myshopify.com',
  'osterrob.myshopify.com',
  'nymphenburg.myshopify.com',
  'masterplanshop-spirale.myshopify.com',
  'picollet-global.myshopify.com',
  'paulsliquor-com-au.myshopify.com',
  'low-n-slow-bbq.myshopify.com',
  'petermanning.myshopify.com',
  'ostarrub.myshopify.com',
  'furnitureoptionsperth.myshopify.com',
  'synergie-skin-nz.myshopify.com',
  'luxury-jewels-of-st-leon.myshopify.com',
  'glazzio-surfaces.myshopify.com',
  'glanzstucke-aviano-gmbh.myshopify.com',
  'kc-custom-hardwoods.myshopify.com',
  'gb-abbigliamento.myshopify.com',
  'fradetteretail.myshopify.com',
  'geoghegans-of-navan.myshopify.com',
  'icowhide.myshopify.com',
  'kaiofcards-com.myshopify.com',
  'kerry-agribusiness.myshopify.com',
  'oddball-oddity.myshopify.com',
  'jennys-boutique-cork.myshopify.com',
  'plejeshop-dk.myshopify.com',
  'bubledon.myshopify.com',
  'astral-theme-development.myshopify.com',
  'eagleclothingsa.myshopify.com',
  'bellamiabv.myshopify.com',
  'blushandlumber.myshopify.com',
  'boheme-crystal.myshopify.com',
  'pila-rings.myshopify.com',
  'charlesandivy.myshopify.com',
  'blue-white-collar.myshopify.com',
  'apres-nail.myshopify.com',
  'brown-ginger.myshopify.com',
  'angelamonacojewelry.myshopify.com',
  'belmontinc.myshopify.com',
  '247lingerie.myshopify.com',
  'wasabi-nomal.myshopify.com',
  'hobby-land-nz.myshopify.com',
  'sample0193.myshopify.com',
  'twowheelsempire.myshopify.com',
  'gellydrops-dev.myshopify.com',
  'shop-suki-zamboanga.myshopify.com',
  'ruglove-co-uk.myshopify.com',
  'seekshine.myshopify.com',
  'part-and-parcel-au.myshopify.com',
  'vela-sciences.myshopify.com',
  'earth-hero-gifting.myshopify.com',
  'cks-brands-b2b.myshopify.com',
  'disndis.myshopify.com',
  'ideal-garden-lights.myshopify.com',
  'cheeky-baby-boutique-rome.myshopify.com',
  'imperialjewelleryaus.myshopify.com',
  'ashleighbergman.myshopify.com',
  'zutterusa.myshopify.com',
  'edexdeals.myshopify.com',
  'sharpedge.myshopify.com',
  'gosportcom.myshopify.com',
  'steelmade.myshopify.com',
  'love-luggage.myshopify.com',
  'annabeck.myshopify.com',
  'glamfleur-com.myshopify.com',
  'shopatmeta.myshopify.com',
  'eu-kendamil-2-0.myshopify.com',
  'alhafidh.myshopify.com',
  'molteni-shop-us.myshopify.com',
  'lings-linen.myshopify.com',
  'tier-1-online.myshopify.com',
  'petstop-ireland.myshopify.com',
  'word-on-fire.myshopify.com',
  'cinqasept.myshopify.com',
  'bazaatest.myshopify.com',
  'bowermans-au.myshopify.com',
  'sea-to-summit-australia.myshopify.com',
  'sts-distribution-b2c.myshopify.com',
  'omnia-brush.myshopify.com',
  'display-geek-inc.myshopify.com',
  'run42store.myshopify.com',
  'gowesty.myshopify.com',
  'gabriela-hearst.myshopify.com',
  'lulusar-fashion.myshopify.com',
  'ducati-sydney.myshopify.com',
  'copenhagen-muse-com.myshopify.com',
  'about-living-uk.myshopify.com',
  'crocsvietnam.myshopify.com',
  'jewelleryroom.myshopify.com',
  'tiesta-tea-1.myshopify.com',
  'thegoodwineshop.myshopify.com',
  'thats-so-fetch-boutique.myshopify.com',
  'a751fd-15.myshopify.com',
  'planetadelibros.myshopify.com',
  'topnsport.myshopify.com',
  'golfdealsandsteals.myshopify.com',
  'k-gold-international.myshopify.com',
  'thatssofetchusa.myshopify.com',
  'kamakura-shirts-global-online.myshopify.com',
  'protein-package.myshopify.com',
  'trekell.myshopify.com',
  'nova-clothing-uk.myshopify.com',
  'shop-ab-shop.myshopify.com',
  'nordica-4753.myshopify.com',
  'turra-music.myshopify.com',
  'pedersoli-casa.myshopify.com',
  'toccotoscano.myshopify.com',
  'xn-t0haaa.myshopify.com',
  'bliss-products-and-services.myshopify.com',
  'kudrnatevlasy.myshopify.com',
  'ridefox-dev.myshopify.com',
  'kolane-store.myshopify.com',
  'the-glowrituals.myshopify.com',
  'springfield-ksa.myshopify.com',
  'womensecret-ksa.myshopify.com',
  'la-vie-en-rose-ksa.myshopify.com',
  'cutlery-and-more-llc.myshopify.com',
  'raceface-ca.myshopify.com',
  'henne-prod.myshopify.com',
  'addisoncollection.myshopify.com',
  'patagonia-argentina.myshopify.com',
  'athlete-body.myshopify.com',
  'pittman-ireland.myshopify.com',
  'the-good-meal-co.myshopify.com',
  'soyaconcept-com.myshopify.com',
  'coeur-de-lion-it.myshopify.com',
  'coeur-de-lion-fr.myshopify.com',
  'coeur-de-lion-world.myshopify.com',
  'coeur-de-lion.myshopify.com',
  'coeur-de-lion-uk.myshopify.com',
  'berghoffshop.myshopify.com',
  'dsrcv.myshopify.com',
  'timpanys-dress-agency.myshopify.com',
  'arcteryxxjp.myshopify.com',
  'goods-dept-store.myshopify.com',
  'partica-balloons.myshopify.com',
  'oneill-canada-new-en-live.myshopify.com',
  'originalpenguinuk.myshopify.com',
  'seatosummitusa.myshopify.com',
  'moderntribe.myshopify.com',
  'petalura.myshopify.com',
  'bygge-bo.myshopify.com',
  'glutenfreeshop-co-nz.myshopify.com',
  'sprocket-and-gear.myshopify.com',
  'liquor-shed-2022.myshopify.com',
  'fabricofsociety-luxury.myshopify.com',
  'trophyshopper.myshopify.com',
  'ool-ws.myshopify.com',
  'itsjuliet.myshopify.com',
  'gryphonstrings.myshopify.com',
  'gloryfeel-es.myshopify.com',
  'cocoandlola.myshopify.com',
  'yardsstore.myshopify.com',
  'soupi.myshopify.com',
  'pendleton-can.myshopify.com',
  'wrapped-cootamundra-au.myshopify.com',
  'jeansmate-online.myshopify.com',
  'thesortingtable.myshopify.com',
  'c3-bobby-jones.myshopify.com',
  'hydropeptide-pro.myshopify.com',
  'depeche-dan-dkk.myshopify.com',
  'hydropeptidestore.myshopify.com',
  'watch-us-women-oakville.myshopify.com',
  'sportvibes-b2b.myshopify.com',
  'vintagemeetshype.myshopify.com',
  'greatlakescoin.myshopify.com',
  'atlas-resell-management.myshopify.com',
  'mobelkompagniet.myshopify.com',
  'soulceramics.myshopify.com',
  'ocean-acaju.myshopify.com',
  'casadiluce.myshopify.com',
  '18fd2e-3a.myshopify.com',
  'way-out-west-trading-co.myshopify.com',
  'aunoir.myshopify.com',
  'sense-of-taste-liquor-stores.myshopify.com',
  'fourstrokeroma-com.myshopify.com',
  'liner-and-elsen.myshopify.com',
  'takedamegane.myshopify.com',
  'portergulch.myshopify.com',
  'earpieces-direct.myshopify.com',
  'th-paint-by-numbers.myshopify.com',
  'helmetking-0001.myshopify.com',
  'diamondenim.myshopify.com',
  'brandzone-dk.myshopify.com',
  'shukr-clothing.myshopify.com',
  'jvr-enterprises-llc.myshopify.com',
  'modeltrainmarket.myshopify.com',
  'tiger-lily-boutique-shop.myshopify.com',
  'brigid-mclaughlin.myshopify.com',
  'foe-dear.myshopify.com',
  'livefashionable.myshopify.com',
  'butcher-block-pro.myshopify.com',
  'ella-jayne-home.myshopify.com',
  'ubierz-sie.myshopify.com',
  'makoba-pens.myshopify.com',
  'sanrio-na.myshopify.com',
  'spiritpieces.myshopify.com',
  'stephen-einhorn-jewellery.myshopify.com',
  'sole-priorities.myshopify.com',
  'milluflora-weex.myshopify.com',
  'title-boxing-llc.myshopify.com',
  'findlay-market.myshopify.com',
  'urbanrevivointl.myshopify.com',
  'tweed-valley-bikes.myshopify.com',
  'sworldinc-dev.myshopify.com',
  'shopstateside-com.myshopify.com',
  'globewest.myshopify.com',
  'aquabatics.myshopify.com',
  'glennbradford.myshopify.com',
  'lobjet-dev-uk.myshopify.com',
  'superior-sewing.myshopify.com',
  'lobjet-dev-eu.myshopify.com',
  'yolke.myshopify.com',
  'sand-dollar-dubai.myshopify.com',
  'sexyshoes-2.myshopify.com',
  'v-yamazaki.myshopify.com',
  'emerald-doors-ltd.myshopify.com',
  'dbesh.myshopify.com',
  'fairtradejewellery.myshopify.com',
  'sani-tech-ca.myshopify.com',
  'info-4649.myshopify.com',
  'ron-daley-motorcycles.myshopify.com',
  'prive-porter.myshopify.com',
  'grwwinecollection.myshopify.com',
  'greygoatsupply.myshopify.com',
  'hcl-clamping-uk-europe.myshopify.com',
  'emptyvase.myshopify.com',
  'jrflooringdirect.myshopify.com',
  'donnybrook-fair-ire.myshopify.com',
  'rosen-sound-llc.myshopify.com',
  'ros-oir-boutique.myshopify.com',
  'anabolix-nutrition.myshopify.com',
  'gameday-graduate.myshopify.com',
  'escentials-production.myshopify.com',
  'volkanica-cl.myshopify.com',
  'skin-ski-and-surf.myshopify.com',
  'tattys-prod.myshopify.com',
  'potomac-river-running.myshopify.com',
  'pivene.myshopify.com',
  'orangewallz-staging.myshopify.com',
  'sheenas-boutique-ireland.myshopify.com',
  'archival-designs.myshopify.com',
  'akasa-partner-gulv.myshopify.com',
  'golden-age-wine.myshopify.com',
  'pacifieronline.myshopify.com',
  'vics-meat.myshopify.com',
  'ye-olde-rock-shop.myshopify.com',
  'oxy-shop-x.myshopify.com',
  'gtap-factory-store.myshopify.com',
  'apl-athletic-propulsion-labs.myshopify.com',
  'intermobilifurniture.myshopify.com',
  'nellacutlery.myshopify.com',
  'shopbasquet.myshopify.com',
  'fashionkind-bbc.myshopify.com',
  'infinite-body-piercing-inc.myshopify.com',
  'territoryahead.myshopify.com',
  'go-sport-uae.myshopify.com',
  'vonn-com.myshopify.com',
  'spy-tex-time.myshopify.com',
  'megapacas.myshopify.com',
  'adibs-persian-rugs.myshopify.com',
  'madison-creek-outfitters.myshopify.com',
  'c8831b-2.myshopify.com',
  'tackle-west.myshopify.com',
  'luxe-link-au.myshopify.com',
  'skikeller.myshopify.com',
  'greboutlet.myshopify.com',
  'rodelag-panama.myshopify.com',
  'ascent-comfort-plus.myshopify.com',
  'lokshop-nl.myshopify.com',
  'boutiquelittle.myshopify.com',
  'luna-sandals.myshopify.com',
  'austral-herbs-prod.myshopify.com',
  'legebyen.myshopify.com',
  'katydidwholesale.myshopify.com',
  'sole-city-shoes.myshopify.com',
  'sheilafleetjewellery.myshopify.com',
  'factory-buys.myshopify.com',
  'furtherfaster.myshopify.com',
  'keepers-collective.myshopify.com',
  'opposite-wall.myshopify.com',
  'zabecca-living.myshopify.com',
  'cellar-com.myshopify.com',
  'opulent-jewelers.myshopify.com',
  'shop-dagama-spirits.myshopify.com',
  'oranjwine.myshopify.com',
  'madaluxetime-com.myshopify.com',
  '9f06d3-71.myshopify.com',
  'vloerenmarkt-nl.myshopify.com',
  'yzstorejp.myshopify.com',
  'maisonspecial.myshopify.com',
  'dir-direct.myshopify.com',
  'bombayshirts-india-prod.myshopify.com',
  'artpartsfinearts.myshopify.com',
  'velluttoro.myshopify.com',
  'sparky-online-store.myshopify.com',
  'sivana.myshopify.com',
  'star-wars-autograph-universe.myshopify.com',
  'stockbjj.myshopify.com',
  'tienda-manilla.myshopify.com',
  'sip-wines-shop.myshopify.com',
  'sabotshop.myshopify.com',
  'shoegrab.myshopify.com',
  'luxwood-retailer.myshopify.com',
  'pure-performance-shop.myshopify.com',
  'merchants-on-long-store.myshopify.com',
  'best-uniform-store.myshopify.com',
  'nordelegastro.myshopify.com',
  'ourkidsasd.myshopify.com',
  'libertysport.myshopify.com',
  'millennium-shoes.myshopify.com',
  'patio-fever.myshopify.com',
  'premier-table-linens-ptl.myshopify.com',
  'motocentral.myshopify.com',
  'gallery-33-nz.myshopify.com',
  'lampeagenten.myshopify.com',
  'wearelavishkitchenisland.myshopify.com',
  'kidomeimoku.myshopify.com',
  'kelty-pelechytik-fine-jewellery.myshopify.com',
  'seconda-vita-fashion.myshopify.com',
  'lofi-store.myshopify.com',
  'waterloo-bathrooms-store.myshopify.com',
  'badbrownie.myshopify.com',
  'byasbaek.myshopify.com',
  'richardboyddunlop.myshopify.com',
  'customhoj.myshopify.com',
  'sorella-boutique-gourmande.myshopify.com',
  'blazer-for-men.myshopify.com',
  'chique-dresses.myshopify.com',
  'brubaker-store.myshopify.com',
  'by-baby.myshopify.com',
  'billiebars.myshopify.com',
  'dailybrat.myshopify.com',
  'artisanbeerco.myshopify.com',
  'salomonjp.myshopify.com',
  'edenbrothers.myshopify.com',
  'bulkwildflowers.myshopify.com',
  'ecapcityjapan.myshopify.com',
  'luterna.myshopify.com',
  'sawada-marche.myshopify.com',
  'apsneaker.myshopify.com',
  'all-the-right.myshopify.com',
  'the-vintage-leopard.myshopify.com',
  'actoncanada.myshopify.com',
  'ingridandisabel.myshopify.com',
  'decofurn-co-za.myshopify.com',
  'thetrustsociety-com.myshopify.com',
  'yitm2021.myshopify.com',
  'shop-cowboy-specialist.myshopify.com',
  'snackathon-foods.myshopify.com',
  'totalelement.myshopify.com',
  'retykle.myshopify.com',
  'countrylivingmarketplace.myshopify.com',
  'les-coupons-de-saint-pierre.myshopify.com',
  'cat-tree-king-australia.myshopify.com',
  'fallenfrontnz.myshopify.com',
  'akronym-co.myshopify.com',
  'olive-oil-lovers.myshopify.com',
  'glory-connection.myshopify.com',
  'getstrung.myshopify.com',
  'dansons-medical.myshopify.com',
  'store-nissin.myshopify.com',
  'figurejp.myshopify.com',
  'goodtech.myshopify.com',
  'my-motorcycle-parts.myshopify.com',
  'tatsumura-textile.myshopify.com',
  'hicks-nurseries.myshopify.com',
  'marianicola.myshopify.com',
  'mabo-kids.myshopify.com',
  'grandseiko-boutiqueonline.myshopify.com',
  'junod-lausanne.myshopify.com',
  'kellyloves.myshopify.com',
  'ninyes-fi.myshopify.com',
  'thought-clothing-uk.myshopify.com',
  'eikopearl.myshopify.com',
  'fitnessshop-ec.myshopify.com',
  'ellibelle-jewellery.myshopify.com',
  'almalittera.myshopify.com',
  'mamas-papas-ie.myshopify.com',
  'mamas-papas-uk.myshopify.com',
  'zlinedealers.myshopify.com',
  'vorhangschweiz.myshopify.com',
  'verve-wine-nyc.myshopify.com',
  'habitat-pet-supplies.myshopify.com',
  'wine-on-sale.myshopify.com',
  'felice-lifedesign.myshopify.com',
  'bksshoes.myshopify.com',
  'effero-milano-marittima.myshopify.com',
  'novusinnercircle.myshopify.com',
  'lafavoritanovus.myshopify.com',
  'greenpan-us.myshopify.com',
  'chewy-chews1.myshopify.com',
  'shop-campania.myshopify.com',
  'organic-delivery-co.myshopify.com',
  'the-cai-store.myshopify.com',
  'dotboards.myshopify.com',
  'computer-overhauls.myshopify.com',
  'kipling-kuwait.myshopify.com',
  'sarah-layton.myshopify.com',
  'secretlinenstore-uk.myshopify.com',
  'alexoonew.myshopify.com',
  'cheering-ad.myshopify.com',
  'tog24.myshopify.com',
  'bills-tool-store.myshopify.com',
  'homeland-ie.myshopify.com',
  'titan-tools-direct.myshopify.com',
  '4b6921-ec.myshopify.com',
  'chairlines.myshopify.com',
  'supersports-vietnam.myshopify.com',
  'missjacobslittlelearners.myshopify.com',
  'butikemsig.myshopify.com',
  'respod.myshopify.com',
  'mhaps.myshopify.com',
  'empireskateshop.myshopify.com',
  'nella-cutlery.myshopify.com',
  'nvgtn.myshopify.com',
  'huippukivacom.myshopify.com',
  'studio-gallery-group.myshopify.com',
  'korendytr.myshopify.com',
  'sisterjane-marketplace.myshopify.com',
  'treadwright.myshopify.com',
  'campania-vietnam.myshopify.com',
  'did-electrical.myshopify.com',
  'blade-tech-holsters.myshopify.com',
  'barcomade.myshopify.com',
  'spiritlytrade.myshopify.com',
  'santa-barbara-aquatics.myshopify.com',
  'barlibrary.myshopify.com',
  '5de383-db.myshopify.com',
  'darts-corner-ltd.myshopify.com',
  'globe-brand.myshopify.com',
  'farahuk.myshopify.com',
  'salty-clothing.myshopify.com',
  'glass-alchemy.myshopify.com',
  'tupperware-my.myshopify.com',
  'indoera-gh.myshopify.com',
  'muzzle-loaders.myshopify.com',
  'dmd-skin-science.myshopify.com',
  'hurdleys-office-furniture.myshopify.com',
  'fmnjp.myshopify.com',
  'conservatory-archives.myshopify.com',
  'jacobs-photo-and-digital.myshopify.com',
  'early-music-shop.myshopify.com',
  'lindyegalloway-staging.myshopify.com',
  'the-tech-den-1.myshopify.com',
  'dixie-divers-fla.myshopify.com',
  'north-workshop.myshopify.com',
  'outdoorsuppylco.myshopify.com',
  'memsaab-kbx.myshopify.com',
  'd69a3e-17.myshopify.com',
  'shukronline-usa.myshopify.com',
  'dk-wasabiconcept.myshopify.com',
  'co-op-superstores.myshopify.com',
  'corteva-agriscience-bulgaria.myshopify.com',
  'de-wasabiconcept.myshopify.com',
  'moogoo-eu.myshopify.com',
  'se-wasabiconcept.myshopify.com',
  'copenhagen-muse-de.myshopify.com',
  'schwartzvonhalen-com.myshopify.com',
  'kendamil-store.myshopify.com',
  'atomic-japan.myshopify.com',
  'moogoo-usa.myshopify.com',
  'moogoo-ireland.myshopify.com',
  'petaandjainau.myshopify.com',
  'rhr-pets-uk.myshopify.com',
  'a62251.myshopify.com',
  'daalshome.myshopify.com',
  'moogoo-nz.myshopify.com',
  'jumbo-computer.myshopify.com',
  'liperin.myshopify.com',
  'buychari-ec.myshopify.com',
  'orientaltraffic.myshopify.com',
  'dr-ashley.myshopify.com',
  'mule-expedition-outfitters.myshopify.com',
  'toririchard-com.myshopify.com',
  'fredbe718.myshopify.com',
  'autify-charles-fish-demo.myshopify.com',
  'oneclickservers.myshopify.com',
  'reinehr-verlag.myshopify.com',
  'brix26.myshopify.com',
  'moogoo-uk.myshopify.com',
  'lamuscle.myshopify.com',
  'thatssofetchuk.myshopify.com',
  'fasmas-de.myshopify.com',
  'akronym-eu.myshopify.com',
  'the-urban-mill.myshopify.com',
  'love-co-pte-ltd.myshopify.com',
  'givenchy-beauty-ksa.myshopify.com',
  'ce0e41.myshopify.com',
  'atomic-australia.myshopify.com',
  'diamonds-plus-jewellers.myshopify.com',
  'lamuscle-usa.myshopify.com',
  'tom-teddy-europe.myshopify.com',
  'veloo-bikes.myshopify.com',
  'crescent-brands.myshopify.com',
  'fruitloops-kitesurfing-school.myshopify.com',
  'nba-kuwait.myshopify.com',
  'h-roberts.myshopify.com',
  'dartscorner-usa.myshopify.com',
  'assouline-wholesale.myshopify.com',
  'uga-theme.myshopify.com',
  'zoey-int.myshopify.com',
  'cleanline-surf.myshopify.com',
  'drmattc.myshopify.com',
  'csa-allegra-k.myshopify.com',
  'cross-clothet.myshopify.com',
  'gloryfeel-it.myshopify.com',
  'zoey-de.myshopify.com',
  'shredly.myshopify.com',
  'minimumwardrobe.myshopify.com',
  'gravitypope-v2.myshopify.com',
  'sea-to-summit-uk.myshopify.com',
  'champion-fasteners.myshopify.com',
  'trade-warehouse-1947.myshopify.com',
  'store-oumigyuu.myshopify.com',
  'nella-wholesale.myshopify.com',
  'draft-portal.myshopify.com',
  'simoneau-test-atoo.myshopify.com',
  'ryui-store-en.myshopify.com',
  'king-seeds-nz.myshopify.com',
  'costconext.myshopify.com',
  'decofurnsa-sandbox.myshopify.com',
  'keoghans-showcase.myshopify.com',
  'mlb-th.myshopify.com',
  '7dd661.myshopify.com',
  'tabletop-nikko.myshopify.com',
  'adrift-clothing-wholesale.myshopify.com',
  'bjs-raw-pet-food.myshopify.com',
  'abundantearthworks.myshopify.com',
  'sgtennishub.myshopify.com',
  'ultravino.myshopify.com',
  'taburo-webstore.myshopify.com',
  'mytitlestore.myshopify.com',
  'livehelfi-fr.myshopify.com',
  'ulenspop.myshopify.com',
  'sleep-village-uk.myshopify.com',
  'kikatsu.myshopify.com',
  'teppana-fr.myshopify.com',
  'billy-footwear-canada.myshopify.com',
  'luxbaby1.myshopify.com',
  'bion-my.myshopify.com',
  'livehelfi-de.myshopify.com',
  'ten-little-dev.myshopify.com',
  'just-hockey-source-for-sports.myshopify.com',
  'techoman-nz.myshopify.com',
  'livehelfi-nl.myshopify.com',
  'zoey-dk.myshopify.com',
  'spiritclothingireland.myshopify.com',
  'llantarcol.myshopify.com',
  'leveteroom-dk.myshopify.com',
  'kemuja.myshopify.com',
  'leveteroom-se.myshopify.com',
  'nba-saudi-arabia.myshopify.com',
  'captain-frothbeard.myshopify.com',
  'nba-qatar.myshopify.com',
  'mynameisted.myshopify.com',
  'g2000th.myshopify.com',
  'broadway-and-sons.myshopify.com',
  'treadwright-ca.myshopify.com',
  'rafiki-au.myshopify.com',
  'kraakmantuinmachines.myshopify.com',
  'piranhaoffroad.myshopify.com',
  'yellow-dog-flyfish.myshopify.com',
  'yoki-japaneseshop.myshopify.com',
  'destinationfabrics.myshopify.com',
  'titanelectronics-pr.myshopify.com',
  'tcmtmotor.myshopify.com',
  'inweave.myshopify.com',
  'festivitees-com.myshopify.com',
  'kids-print-fabrics.myshopify.com',
  'kenelestore.myshopify.com',
  'emily-warden-designs-site.myshopify.com',
  'hydronics-depot-inc.myshopify.com',
  'livehelfi-en.myshopify.com',
  'alfresco-living-sl.myshopify.com',
  'gfw-clothing-without-labels.myshopify.com',
  'wilson-au.myshopify.com',
  'wildbounds.myshopify.com',
  'chenson-mexico.myshopify.com',
  'scissorsandmore.myshopify.com',
  'modern-minimal-deco.myshopify.com',
  '8dio-com.myshopify.com',
  'sujimyshopify.myshopify.com',
  'meir-za.myshopify.com',
  'acdcdrives.myshopify.com',
  'chamonix-skin-care.myshopify.com',
  'willowshoes.myshopify.com',
  'theclinic.myshopify.com',
  'stoemp-shop.myshopify.com',
  'p209.myshopify.com',
  '2d836f-3.myshopify.com',
  'usa-service-animal-registration.myshopify.com',
  'f14534-2.myshopify.com',
  'babytunes.myshopify.com',
  'shoesuite.myshopify.com',
  'i-miller-microscopes.myshopify.com',
  'pixusvillagekids.myshopify.com',
  'secret-compass-new.myshopify.com',
  'onesleep-serbia.myshopify.com',
  'berenik-boutique.myshopify.com',
  'rml-health-wellness.myshopify.com',
  'suter-racing-products.myshopify.com',
  'handicraft-prym.myshopify.com',
  'framing-to-a-t-melbourne.myshopify.com',
  'www-isadoralife-com.myshopify.com',
  'steep-mountain-tea.myshopify.com',
  'poliform-au.myshopify.com',
  'rembrandt-1946.myshopify.com',
  'quadrum-gallery.myshopify.com',
  's-lok.myshopify.com',
  'divertimenti-uk.myshopify.com',
  'franklinarts.myshopify.com',
  'motostealz-com.myshopify.com',
  'morenos-wear.myshopify.com',
  'terra-firma-automotive.myshopify.com',
  'rachelrileylondoninc.myshopify.com',
  'stagingxplct.myshopify.com',
  'site-garant.myshopify.com',
  'uniformity-schools.myshopify.com',
  'poldekker.myshopify.com',
  'perfumeparlouruk.myshopify.com',
  'leonidov-akupunktur.myshopify.com',
  'paljoeyclothing.myshopify.com',
  '9ef9b1.myshopify.com',
  'image-pro-international.myshopify.com',
  'drones-xpress.myshopify.com',
  'ci-store-7176.myshopify.com',
  'a-mans-band.myshopify.com',
  'kappahl-newbie.myshopify.com',
  'misfit-diamonds.myshopify.com',
  'd76af7-3.myshopify.com',
  'robert-welch-trade.myshopify.com',
  'pelagic-gear.myshopify.com',
  'strings-and-things-music-store.myshopify.com',
  'spunkies-trunk.myshopify.com',
  'jeffreycampbell.myshopify.com',
  'analog-cases.myshopify.com',
  'radhica.myshopify.com',
  'gstjewelers.myshopify.com',
  'christy-ng.myshopify.com',
  'corofoods.myshopify.com',
  'clarinetallmusic.myshopify.com',
  'rachel-comey.myshopify.com',
  'tiny-rituals.myshopify.com',
  'lunalaeb2b.myshopify.com',
  'brothervellies.myshopify.com',
  'ifilters.myshopify.com',
  'foolsgoldrecs.myshopify.com',
  'vanguardworld-jp.myshopify.com',
  'electric-fireplaces-plus.myshopify.com',
  'tassel-children-shoes.myshopify.com',
  'ping-pong-champ.myshopify.com',
  'bernardo-fashions.myshopify.com',
  'pro-pool-store.myshopify.com',
  'alessentials.myshopify.com',
  'simplycutetees.myshopify.com',
  'lcoutureuae.myshopify.com',
  'watchesandbeyond.myshopify.com',
  'the-golf-shop-at-cutten-fields.myshopify.com',
  'above-the-collar.myshopify.com',
  'buyintrade.myshopify.com',
  'rs-cleaning-machines.myshopify.com',
  'meerminuk.myshopify.com',
  'meerminshoes.myshopify.com',
  'greenworks-coffee.myshopify.com',
  'newerasa.myshopify.com',
  'hitchleyandharrow.myshopify.com',
  'breaker-hunters-test.myshopify.com',
  'packer-shoes.myshopify.com',
  'mitavite-nz.myshopify.com',
  'mizuno-nz-prod.myshopify.com',
  'macgregorandmacduff.myshopify.com',
  'alwan1.myshopify.com',
  'rain-chains-in-a-nutshell.myshopify.com',
  'myselflingerie-com.myshopify.com',
  'ettika-2.myshopify.com',
  'clinikally.myshopify.com',
  'johari-west.myshopify.com',
  'spinchy-v2.myshopify.com',
  'sorelleukcom.myshopify.com',
  'soundpaint.myshopify.com',
  'rtfact-flowers.myshopify.com',
  'mixperfume.myshopify.com',
  'packyarddk.myshopify.com',
  'quality-surfboards-hawaii.myshopify.com',
  'jigsaw-puzzles-direct.myshopify.com',
  'cygnett.myshopify.com',
  'char-le-maine.myshopify.com',
  'modern-millie-shop.myshopify.com',
  'minkycouture-com.myshopify.com',
  'angel-studios-inc.myshopify.com',
  'www-gioelleria-amadori-com.myshopify.com',
  'panter-and-hall.myshopify.com',
  'valuepetsupplies-com.myshopify.com',
  'butler-wilson.myshopify.com',
  'hlgross.myshopify.com',
  'curvy-usa.myshopify.com',
  'brazilian-direct.myshopify.com',
  'thepomadeshop.myshopify.com',
  'pookie-baby-boutique.myshopify.com',
  'espace-s.myshopify.com',
  'bull-and-briar-leather-llc.myshopify.com',
  'state-of-escape.myshopify.com',
  'brogaarden.myshopify.com',
  'ro37.myshopify.com',
  'jb-peel-coffee.myshopify.com',
  'chado-uzbekistan.myshopify.com',
  'fabrics-cl.myshopify.com',
  'foto-cls.myshopify.com',
  'mount-vernon-coin.myshopify.com',
  'dirbhos.myshopify.com',
  '736bc9.myshopify.com',
  'pixuskeekokids.myshopify.com',
  'snow-moon-press-shop.myshopify.com',
  'chippindale-plant.myshopify.com',
  'watts-jp.myshopify.com',
  'style-mouktika.myshopify.com',
  'away-that-day.myshopify.com',
  'nosix-co-uk.myshopify.com',
  'automic.myshopify.com',
  'camperdown-jewellers.myshopify.com',
  'australian-bush-flower-essence.myshopify.com',
  'loon-outdoors.myshopify.com',
  'handt-uat1.myshopify.com',
  'victor-schools.myshopify.com',
  'courir-uae.myshopify.com',
  'uk-radiators.myshopify.com',
  'wholesale-jewelry-website.myshopify.com',
  'enen-store.myshopify.com',
  'outsourceit-fi.myshopify.com',
  '12am-za.myshopify.com',
  'contact-coffee.myshopify.com',
  'diciembredosnueve.myshopify.com',
  '31f3b7-44.myshopify.com',
  'd553ce-3.myshopify.com',
  'nadri-test.myshopify.com',
  'supplydoc-production.myshopify.com',
  'bellabu.myshopify.com',
  'tumble-canada.myshopify.com',
  'americandarlingbags.myshopify.com',
  'the-library-ladder-company.myshopify.com',
  'd38c4c.myshopify.com',
  'kykth1-bd.myshopify.com',
  'laverne-ksa-live.myshopify.com',
  'doona.myshopify.com',
  'oirtonics.myshopify.com',
  'f45b77-ba.myshopify.com',
  'rv6-wholesale.myshopify.com',
  'wuforia.myshopify.com',
  'kerata.myshopify.com',
  'e4aa55-2.myshopify.com',
  'veux-tu-une-biere.myshopify.com',
  'neighbors-wine-store.myshopify.com',
  'barna-resources.myshopify.com',
  'starkey-outdoor.myshopify.com',
  '54769c-2.myshopify.com',
  '256503.myshopify.com',
  'u90soccer.myshopify.com',
  'the-appliance-guys-au.myshopify.com',
  'suzysfine-jewellery.myshopify.com',
  'c90ad5-2.myshopify.com',
  'pool-marts.myshopify.com',
  'office-computers.myshopify.com',
  'silk-or-lace.myshopify.com',
  'toms-australia.myshopify.com',
  '761c83-3.myshopify.com',
  'jonny-lipford-music.myshopify.com',
  '7e7e84.myshopify.com',
  'blauerboardshop.myshopify.com',
  'satoyaku.myshopify.com',
  'o-online-store.myshopify.com',
  '0f5049-0c.myshopify.com',
  'fingersuit-japan.myshopify.com',
  'densandkennels.myshopify.com',
  'ogrpca.myshopify.com',
  'ogrnasa.myshopify.com',
  'globe-trotter-chinese.myshopify.com',
  'spluss-regeltechnik.myshopify.com',
  'shuggie-co.myshopify.com',
  'eddiebauer-jp.myshopify.com',
  'shop-chevalier.myshopify.com',
  'a8c46d-4.myshopify.com',
  'cielkocka.myshopify.com',
  'estate-watch-and-jewelry-company.myshopify.com',
  'dioramaliving.myshopify.com',
  'chicoryhome.myshopify.com',
  'loomandloft2.myshopify.com',
  'gds-gold-diamond-source.myshopify.com',
  'mindismithnyc.myshopify.com',
  'shopnewrepublic.myshopify.com',
  'gmpopcorn.myshopify.com',
  'royal-vanities-au.myshopify.com',
  'kofi-com.myshopify.com',
  'wearhouse-com-au.myshopify.com',
  'wellsons.myshopify.com',
  '2nd-to-none-co.myshopify.com',
  'jvalentine.myshopify.com',
  'd9daeb-04.myshopify.com',
  'ceiling-speakers-co-uk.myshopify.com',
  'digger-tactical-australia.myshopify.com',
  'camscords.myshopify.com',
  'respiro-indonesia.myshopify.com',
  'beauchapeau-hat-shop.myshopify.com',
  'kay-unger-3.myshopify.com',
  'doghouse-distillery-new-build.myshopify.com',
  'dbea3f-2.myshopify.com',
  '13606c-3.myshopify.com',
  'pro-australia.myshopify.com',
  'clb-xxiii.myshopify.com',
  'sethi-couture.myshopify.com',
  '9e145c-99.myshopify.com',
  'amoretti.myshopify.com',
  'jacques-tissot.myshopify.com',
  'ipanemasouthafrica.myshopify.com',
  '085e09-2.myshopify.com',
  'fith-online-store.myshopify.com',
  'verb-by-pallavi-singhee.myshopify.com',
  'c044bc-2.myshopify.com',
  'organics-ph.myshopify.com',
  'the-index-luxury-cigar-purveyors.myshopify.com',
  'unicbrands.myshopify.com',
  'great-sox.myshopify.com',
  'radiantwholefood.myshopify.com',
  '66a0a0-2.myshopify.com',
  'burdlife.myshopify.com',
  'union-atelier.myshopify.com',
  'one-stop-chilli-shop.myshopify.com',
  'nally-jewels.myshopify.com',
  'abf746-5.myshopify.com',
  '5thgate.myshopify.com',
  'boutique-40-30.myshopify.com',
  'ridersdeluxe.myshopify.com',
  'wildsmith-jewellery.myshopify.com',
  'physiosupplies-uk.myshopify.com',
  'hunters-element.myshopify.com',
  'risud-dev.myshopify.com',
  'paul-edmonds-london.myshopify.com',
  'wham-bam-systems.myshopify.com',
  'nihonkosho.myshopify.com',
  'asia-minor-carpets.myshopify.com',
  '1019e7-3.myshopify.com',
  'lsp-actions.myshopify.com',
  'kandakirat.myshopify.com',
  'dressthebirdaps.myshopify.com',
  'thecookingkingdom.myshopify.com',
  'heart-and-harper.myshopify.com',
  'luna-fied.myshopify.com',
  'bylu.myshopify.com',
  'james-river-laser-equipment.myshopify.com',
  'myclub-one.myshopify.com',
  'linjer.myshopify.com',
  'splay-outlet.myshopify.com',
  'toxtests-com.myshopify.com',
  'jackjones-mallofathens.myshopify.com',
  'victorsportsau.myshopify.com',
  'local-ae.myshopify.com',
  '5c6e7b-2.myshopify.com',
  'zenkindstore.myshopify.com',
  'zenottic-eyeglasses.myshopify.com',
  'trestina.myshopify.com',
  'zeke-collection.myshopify.com',
  'take-five-trading.myshopify.com',
  'f668bd.myshopify.com',
  'ad759b.myshopify.com',
  '97e80e-3.myshopify.com',
  'sabellah.myshopify.com',
  'ddc1cf-2.myshopify.com',
  'prokicksports.myshopify.com',
  'southwest-motorhomes.myshopify.com',
  'the-thrifting-den.myshopify.com',
  'pokebox-australia.myshopify.com',
  'sahara-jewellery.myshopify.com',
  'the-radio-shop.myshopify.com',
  'theshoeparlour.myshopify.com',
  'rtfbikeparts.myshopify.com',
  'strumpbudet.myshopify.com',
  'pro-stock-tennis.myshopify.com',
  'robert-simmonds-clothing.myshopify.com',
  'lostandfound.myshopify.com',
  'global-picollet.myshopify.com',
  'nbluxe-us.myshopify.com',
  'omakase-tokyo.myshopify.com',
  'mytruckerpro.myshopify.com',
  'livinlinens.myshopify.com',
  'parkside-skateshop.myshopify.com',
  'happyaslarrydesigns.myshopify.com',
  'mar-lou-shoes.myshopify.com',
  'ipek-kiramer.myshopify.com',
  'etonic1876.myshopify.com',
  '1235b3-2.myshopify.com',
  'c4b644-2.myshopify.com',
  'eight-one-8604.myshopify.com',
  '64f252.myshopify.com',
  'italeau2.myshopify.com',
  'impactcoach.myshopify.com',
  'happy-eve.myshopify.com',
  'ileava-gems.myshopify.com',
  'flybar1.myshopify.com',
  'justin-davis-online-store.myshopify.com',
  '70f8a8.myshopify.com',
  '6df05c.myshopify.com',
  'mk2parts.myshopify.com',
  '349af0-3.myshopify.com',
  'dnrcustoms-com.myshopify.com',
  'brooklyn-footwear-x-fashion.myshopify.com',
  'cialfaro.myshopify.com',
  'clearfurniture.myshopify.com',
  'atica-brand.myshopify.com',
  'belfield-music.myshopify.com',
  'collectiveoutlet.myshopify.com',
  'babaroo-ie.myshopify.com',
  'discountdressshop.myshopify.com',
  'uyeki-online-shop.myshopify.com',
  'europe-development.myshopify.com',
  'wijaya-gems.myshopify.com',
  'aprilplants.myshopify.com',
  'idealmoda.myshopify.com',
  'needlecart.myshopify.com',
  'naak-uk.myshopify.com',
  'a1598b-2.myshopify.com',
  'e59731.myshopify.com',
  'disposableclouds.myshopify.com',
  'mutual-muse.myshopify.com',
  'treasure-box-by-biani-nz.myshopify.com',
  'theskinnyfoodco.myshopify.com',
  'underleaf-ltd.myshopify.com',
  'scoutandrebel.myshopify.com',
  'yeomamabatik.myshopify.com',
  'piper-finn.myshopify.com',
  'c705b6.myshopify.com',
  'ibex-prodeal.myshopify.com',
  '3688af-2.myshopify.com',
  'gxrjo.myshopify.com',
  'popsy-clothing.myshopify.com',
  'ganemjewelers.myshopify.com',
  'mainlandskate.myshopify.com',
  'shopnse.myshopify.com',
  'shopeverythingbaby.myshopify.com',
  'edibleprintsoncake.myshopify.com',
  'appliance-giant-stark.myshopify.com',
  'eternalsoles.myshopify.com',
  'bijouterie-zbinden.myshopify.com',
  'jocko-fuel.myshopify.com',
  'jocko-fuel-wholesale.myshopify.com',
  'theechelon.myshopify.com',
  'airthreads.myshopify.com',
  'zvoovfashion.myshopify.com',
  'hydrapak.myshopify.com',
  'waangoosg.myshopify.com',
  'zynretail.myshopify.com',
  'enerskin.myshopify.com',
  'lriplwebsote.myshopify.com',
  'l-t-denny-jewelers.myshopify.com',
  'cwjewellers.myshopify.com',
  'gsparisbeauty.myshopify.com',
  'etoile-la-boutique.myshopify.com',
  'vintage-luxe-upcycle.myshopify.com',
  'tailormade-health.myshopify.com',
  'decur2.myshopify.com',
  'paper-and-grace.myshopify.com',
  'ec1867-2.myshopify.com',
  'three-old-guys.myshopify.com',
  '64ad96.myshopify.com',
  'photocopiers-direct.myshopify.com',
  '6afab6-4.myshopify.com',
  'hairlaya.myshopify.com',
  'victorian-ring-company.myshopify.com',
  'rustic-kitchen-bath.myshopify.com',
  'style-centre-wholesale.myshopify.com',
  'candlelight-home.myshopify.com',
  'cncshop-eu.myshopify.com',
  'coolbrandsperu.myshopify.com',
  'ciano-farmer-denim-co.myshopify.com',
  'ralphs-wines-spirits.myshopify.com',
  'leatherup-wholesale.myshopify.com',
  'daugustagioielli.myshopify.com',
  'sunpowerpro.myshopify.com',
  'bairnsdale-horse-centre-1.myshopify.com',
  'silkberrybabyusa.myshopify.com',
  'thehisplacestore.myshopify.com',
  'unboxme-dev.myshopify.com',
  '24953d-3.myshopify.com',
  '947a6b-58.myshopify.com',
  'sport-palace-online.myshopify.com',
  'viinitie-oy.myshopify.com',
  '6aa06b-2.myshopify.com',
  '9ad244.myshopify.com',
  'vintagetest22.myshopify.com',
  'peachy-athletic.myshopify.com',
  'homies-em.myshopify.com',
  'way-funky-deutschland.myshopify.com',
  'q-brands-de.myshopify.com',
  'legacytouch.myshopify.com',
  'mightyjaxx-wholesale-us.myshopify.com',
  'adachi-hanga.myshopify.com',
  'eficonversions.myshopify.com',
  'fitflopth.myshopify.com',
  'levitatesneakers1.myshopify.com',
  'aniclothingin.myshopify.com',
  'wd-electronics.myshopify.com',
  '485d57.myshopify.com',
  'af0055-5d.myshopify.com',
  'warrior-strong-lifestyle.myshopify.com',
  '3bb54e.myshopify.com',
  'australian-boot-company-2.myshopify.com',
  'tile-boutique-new.myshopify.com',
  '83654a-2.myshopify.com',
  'enibbana.myshopify.com',
  'subie-supply-co.myshopify.com',
  '100-futbol-cl.myshopify.com',
  'dugan-technologies.myshopify.com',
  '534639-3.myshopify.com',
  'dmaxstore-com.myshopify.com',
  'horseshoecrab.myshopify.com',
  'yarra-valley-dress-hire.myshopify.com',
  'grapeliving.myshopify.com',
  'motorrad-melbourne.myshopify.com',
  'fashionmaxxxx.myshopify.com',
  'luxe-game-tables.myshopify.com',
  'nolters.myshopify.com',
  'styles-by-soma.myshopify.com',
  'soundtownusa.myshopify.com',
  'white-deer-stationery.myshopify.com',
  'gardenxxx.myshopify.com',
  '63e946-5b.myshopify.com',
  'b1c5b2.myshopify.com',
  '59a642-2.myshopify.com',
  'silicone-lovers.myshopify.com',
  'ausmodshop.myshopify.com',
  'fyieyecare.myshopify.com',
  'the-hair-center-ch.myshopify.com',
  'sox-by-angus-dev.myshopify.com',
  'fc3821.myshopify.com',
  'nanouniverse.myshopify.com',
  'vado-welog-b2c.myshopify.com',
  'plastic-printers-ecomm.myshopify.com',
  'kamashoinc-2.myshopify.com',
  'fynchhatton.myshopify.com',
  '8c9a5b-4.myshopify.com',
  'united-sport-cycle-cad.myshopify.com',
  'momentum-clothing-2.myshopify.com',
  'brawa-shop.myshopify.com',
  'snack-hawaii.myshopify.com',
  '0c8384.myshopify.com',
  'logemann.myshopify.com',
  'barquito-de-papel-pr.myshopify.com',
  'mannahatta.myshopify.com',
  'the-scentroom.myshopify.com',
  'furtex-nz.myshopify.com',
  'ctb-performance-and-accessories.myshopify.com',
  'copymaster-3d.myshopify.com',
  'concept-brands.myshopify.com',
  'deniliquin-jewellers.myshopify.com',
  'minjion.myshopify.com',
  '61201b-4.myshopify.com',
  'high-st-dress-hire.myshopify.com',
  'babyhouse-australia.myshopify.com',
  'postergroup-2019.myshopify.com',
  'ravefix.myshopify.com',
  'ceiling-speaker-world.myshopify.com',
  'jettyhome.myshopify.com',
  'c7d614.myshopify.com',
  '86fce4.myshopify.com',
  'iydjewelry.myshopify.com',
  'mended-hearts-quilting-boutique.myshopify.com',
  'west-coast-garage-2024.myshopify.com',
  'prym-pce.myshopify.com',
  'heide-heinzendorff.myshopify.com',
  'savannah-sevens-western-chic.myshopify.com',
  'brandsmegastore.myshopify.com',
  'rodeoh-b2b.myshopify.com',
  '4babac-3.myshopify.com',
  'rolls-liner.myshopify.com',
  'rauantiques.myshopify.com',
  'number-10-ae.myshopify.com',
  'airgun-market.myshopify.com',
  'evisu-hk.myshopify.com',
  'evisu-jp.myshopify.com',
  'evisu-eu.myshopify.com',
  'the-decorators-1949.myshopify.com',
  'evisu-us.myshopify.com',
  'mygarminstraps.myshopify.com',
  'refashonline.myshopify.com',
  'mynewcastle.myshopify.com',
  'eff7d6-3.myshopify.com',
  'shop-badger-clothing.myshopify.com',
  'melin-brand.myshopify.com',
  'auskistore.myshopify.com',
  'vpracingfuels.myshopify.com',
  'cath-eastham-fine-jewelry.myshopify.com',
  'linestogo.myshopify.com',
  'seichile.myshopify.com',
  'brooklyn-bred-since-1930.myshopify.com',
  'masina-diamonds-atlanta.myshopify.com',
  'smegusa.myshopify.com',
  'edward-donna.myshopify.com',
  'buchroeders-jewelers.myshopify.com',
  'whiteleyhealthcare.myshopify.com',
  'levenger.myshopify.com',
  'footmotion-retail.myshopify.com',
  'avahcouturefashion.myshopify.com',
  'qiditech3d.myshopify.com',
  'andrea-morando.myshopify.com',
  'asaspice.myshopify.com',
  'thegateboutique.myshopify.com',
  'kris-gourmet.myshopify.com',
  'otteren.myshopify.com',
  'ridge-uk.myshopify.com',
  'leigh-jay.myshopify.com',
  'wybotpoolstore.myshopify.com',
  'somuaclub.myshopify.com',
  'nao-art-onlineshop.myshopify.com',
  'the-ridge-social.myshopify.com',
  'loohm.myshopify.com',
  '4f1b22-3.myshopify.com',
  'staite-recycled-paper.myshopify.com',
  'lesports.myshopify.com',
  'timfrankclothing.myshopify.com',
  'fdab49-2.myshopify.com',
  'casanolitaa.myshopify.com',
  'yesshopstore.myshopify.com',
  'sunyee.myshopify.com',
  'wisibricks-ch.myshopify.com',
  'mark-lona.myshopify.com',
  'roland-sands-design-4611.myshopify.com',
  '140b10-2.myshopify.com',
  '365fb2-2.myshopify.com',
  'vestibule-zurich.myshopify.com',
  'selby-onlinestore.myshopify.com',
  'truenutritionstore.myshopify.com',
  'sportshopamburgstall.myshopify.com',
  'tusktools-au.myshopify.com',
  'viranijewelers.myshopify.com',
  'tcvm-pet.myshopify.com',
  'racquetguys1.myshopify.com',
  'mettepshop.myshopify.com',
  'oliodiolivo.myshopify.com',
  '611ebf-2.myshopify.com',
  'mobuofficial.myshopify.com',
  'f2d87b.myshopify.com',
  'efmaccessories.myshopify.com',
  'muta-japan.myshopify.com',
  'manta-trading.myshopify.com',
  '0647b8-2.myshopify.com',
  'onkron-canada.myshopify.com',
  'nicola-ross-naas.myshopify.com',
  'meg-lizabet.myshopify.com',
  'homeandearthshop.myshopify.com',
  'fox-fine-jewelry-dev.myshopify.com',
  'houseofexotique.myshopify.com',
  'gripracingusa.myshopify.com',
  'gardentoolshopeu.myshopify.com',
  'jaes-jewelers.myshopify.com',
  'kid-biz.myshopify.com',
  'gem-hunt.myshopify.com',
  'littlepartydress.myshopify.com',
  'inshobby.myshopify.com',
  'fairmountfibers.myshopify.com',
  'carpient.myshopify.com',
  '3e3c4d-2.myshopify.com',
  'bless-silver.myshopify.com',
  'rashidcassimsports.myshopify.com',
  '982bb1-2.myshopify.com',
  'caffetteria-stazione.myshopify.com',
  'bluebells-boutique-belle.myshopify.com',
  'ebb-and-flow-light.myshopify.com',
  '3d0f81-2.myshopify.com',
  'bumbletree-ltd.myshopify.com',
  'dewaldens.myshopify.com',
  'alpenglowsports.myshopify.com',
  'a5a2e4.myshopify.com',
  '686cac.myshopify.com',
  'apreseveryday.myshopify.com',
  '2b-gioielli.myshopify.com',
  'info-179.myshopify.com',
  'aed-team.myshopify.com',
  'hope-clothing-gb.myshopify.com',
  '73b418.myshopify.com',
  'over-the-moon-monkstown-dublin.myshopify.com',
  'mesonart-5653.myshopify.com',
  'top-shelf-wine-spirits.myshopify.com',
  'theonsethomes.myshopify.com',
  'runandfly.myshopify.com',
  'tcastore.myshopify.com',
  'skatescool-shop.myshopify.com',
  'sister-and-soul.myshopify.com',
  '7ed75c.myshopify.com',
  '2e813f.myshopify.com',
  'kidztique-2697.myshopify.com',
  '5f078d.myshopify.com',
  '2amstudioofficial.myshopify.com',
  'italystation.myshopify.com',
  'hamazaki-eyelash-mania.myshopify.com',
  'united-signage.myshopify.com',
  'thecrimie.myshopify.com',
  'spunkypup.myshopify.com',
  'scheestore.myshopify.com',
  'evbwestport.myshopify.com',
  'bedheadpjs.myshopify.com',
  'flowkoolerwaterpumps.myshopify.com',
  'gemsandjewelsuk.myshopify.com',
  '30350e-3.myshopify.com',
  'usbmd.myshopify.com',
  'a1aefd.myshopify.com',
  'nerias.myshopify.com',
  'esmaison.myshopify.com',
  'bortex-fine-tailoring.myshopify.com',
  'iron-equipment-store.myshopify.com',
  'gear-techs-store.myshopify.com',
  '79510b-2.myshopify.com',
  'thbx-shop.myshopify.com',
  'jose-real-shoes.myshopify.com',
  'b12454-2.myshopify.com',
  'houseoftoogood.myshopify.com',
  'united-apparel-liquidators.myshopify.com',
  'www-anjumodi-com.myshopify.com',
  'vanilla-underground-live.myshopify.com',
  'kala-marmoles.myshopify.com',
  'courtneyscandles1992.myshopify.com',
  '73871b.myshopify.com',
  '019d6b-3.myshopify.com',
  'rockandroad-6227.myshopify.com',
  'expertdieselparts.myshopify.com',
  'beauty-plus-chile.myshopify.com',
  'naak-ch.myshopify.com',
  'moana-pasifika.myshopify.com',
  'contact-675.myshopify.com',
  'adore-dance-shoes.myshopify.com',
  'maxinutrition.myshopify.com',
  'flyfishfood.myshopify.com',
  'ce6711-4a.myshopify.com',
  '4093a5-ab.myshopify.com',
  'kinglaser.myshopify.com',
  'burdeens-official.myshopify.com',
  'house-of-jade-home.myshopify.com',
  'tatlerno.myshopify.com',
  'pmr-customs.myshopify.com',
  'murphy-and-mcneil.myshopify.com',
  'cc71dc-d8.myshopify.com',
  'blueridgeoutfitters.myshopify.com',
  'briony-raymond-new-york.myshopify.com',
  'little-bear-and-bean-boutique.myshopify.com',
  'azsport-ro.myshopify.com',
  'keelaoutdoors.myshopify.com',
  'bdc21b-2.myshopify.com',
  '6b7bf7-79.myshopify.com',
  'and-classy.myshopify.com',
  'wwsirl.myshopify.com',
  'hvelplund.myshopify.com',
  '1c912d-2.myshopify.com',
  'the-perfect-workout-8102.myshopify.com',
  'f145f0-4.myshopify.com',
  'qidi3d.myshopify.com',
  'bewleys-tea-coffee.myshopify.com',
  'surfmore.myshopify.com',
  'tracmaster.myshopify.com',
  'ba084c.myshopify.com',
  'ae-stainless-direct.myshopify.com',
  'motoism-test.myshopify.com',
  'haverfordboxnz.myshopify.com',
  'planet-linen-australia.myshopify.com',
  'monicaandandyonline.myshopify.com',
  'bote-au.myshopify.com',
  'wine-vitage.myshopify.com',
  'parrotstation-com.myshopify.com',
  'innosoft-gmbh.myshopify.com',
  'g128store-com.myshopify.com',
  'espresso-planet-staging.myshopify.com',
  '22117b.myshopify.com',
  'rastellis-sandbox.myshopify.com',
  'k9-leathers.myshopify.com',
  'saltaire-antiques.myshopify.com',
  'trovvve.myshopify.com',
  'axercise.myshopify.com',
  'rotatechproducts.myshopify.com',
  'bunker-hill-design-plllc.myshopify.com',
  'thestem.myshopify.com',
  'albercas-y-punto.myshopify.com',
  'hufjapan.myshopify.com',
  'e2054b.myshopify.com',
  'sterenusa-shop.myshopify.com',
  '10b613-3.myshopify.com',
  'native-linum.myshopify.com',
  'madoneco.myshopify.com',
  '86f6a5.myshopify.com',
  'cateye-cycling.myshopify.com',
  'little-treasury-jewelers.myshopify.com',
  'bicycle-collective-utah.myshopify.com',
  'custom-lids-canada.myshopify.com',
  '9e08b5.myshopify.com',
  'de69f6-2e.myshopify.com',
  'whiteriver.myshopify.com',
  'first-colours.myshopify.com',
  'colorado-canyon-enthusiasts.myshopify.com',
  'collegiatepulse.myshopify.com',
  'onrkon-de.myshopify.com',
  'feminine-attractions.myshopify.com',
  'golf-cart-people.myshopify.com',
  'carrdan-preservation-supply.myshopify.com',
  'complete-koi.myshopify.com',
  'pure-cotton-comfort.myshopify.com',
  'united-scope-de.myshopify.com',
  'strapatelier-test.myshopify.com',
  'jackall-online-shop.myshopify.com',
  'bawa-jewellers.myshopify.com',
  'kiltane-shop.myshopify.com',
  'hunterboots-co-jp.myshopify.com',
  '374a6a-2.myshopify.com',
  '724bb7-3.myshopify.com',
  'astoriaweb.myshopify.com',
  'ad806a.myshopify.com',
  '29465b-2.myshopify.com',
  'c2d7d0.myshopify.com',
  '901f3c.myshopify.com',
  'youfiel.myshopify.com',
  'torato2023.myshopify.com',
  'gracia-kids-1890.myshopify.com',
  'paani-ch.myshopify.com',
  'the-gents-store-4714.myshopify.com',
  'ba1b4d.myshopify.com',
  'brooksrunningjp.myshopify.com',
  'achilles-ec.myshopify.com',
  'p-porter.myshopify.com',
  '3431c0.myshopify.com',
  'kraft-music-test.myshopify.com',
  'dripcityjewellers.myshopify.com',
  'ronaldo-jewelry-b2b.myshopify.com',
  'groenensteyn-com.myshopify.com',
  'belmont-sparkle.myshopify.com',
  'gentem-stick.myshopify.com',
  'jocoko.myshopify.com',
  'the-persian-rug-store-1.myshopify.com',
  'medical-spa-supply.myshopify.com',
  'toolbussin.myshopify.com',
  'swell-wellness.myshopify.com',
  'bremner-tcg.myshopify.com',
  '46d8a4-2.myshopify.com',
  'whitecherryboutique.myshopify.com',
  'garage89-1009-3.myshopify.com',
  'music-access-canada.myshopify.com',
  'pell-1990.myshopify.com',
  'ciss-cola.myshopify.com',
  'hammertons.myshopify.com',
  'twisted-thread.myshopify.com',
  'mega-brown-box.myshopify.com',
  'commit-watch.myshopify.com',
  'crossmembers.myshopify.com',
  'borngooduk.myshopify.com',
  'brands-establishment.myshopify.com',
  'pre-packs.myshopify.com',
  'crossfor.myshopify.com',
  'rp-electronics-sa.myshopify.com',
  'liah-by-liat-raziel.myshopify.com',
  'nicole-hd-jewelry.myshopify.com',
  'loccoacaju.myshopify.com',
  'out-of-print-clothing.myshopify.com',
  'blackbear-boutique.myshopify.com',
  'monisha-melwani-jewelry.myshopify.com',
  'keitoya.myshopify.com',
  'kahala-com.myshopify.com',
  'mr-vape-uk.myshopify.com',
  'arpar-shop.myshopify.com',
  'endurance-products-company.myshopify.com',
  'xn-n8jvb278m3eo8wkgij61s.myshopify.com',
  'monitaya.myshopify.com',
  'bella-epoca-zapateria.myshopify.com',
  'mhp-practitioner.myshopify.com',
  'tf-tiles.myshopify.com',
  'classicfightshop.myshopify.com',
  'kinetics-tokyo.myshopify.com',
  'worldofluxuryus-1260.myshopify.com',
  'xn-rss49j3pis1mu86b.myshopify.com',
  'condehouse2.myshopify.com',
  'urban-drivestyle-2.myshopify.com',
  'mykingdom-vietnam.myshopify.com',
  'volo-alte.myshopify.com',
  'bc552b-2.myshopify.com',
  'cords-club.myshopify.com',
  'hi-tec-footsure.myshopify.com',
  'dansonjewelers.myshopify.com',
  'shop-online-timack.myshopify.com',
  'brick-house-in-the-city.myshopify.com',
  'ichimonji-jp-dev01.myshopify.com',
  'shopxclusivesneakers.myshopify.com',
  'hydrogenperoxide.myshopify.com',
  'kleankanteenbe.myshopify.com',
  'happysoaps-se.myshopify.com',
  'rtfacts-dev.myshopify.com',
  'lithos-diamonds.myshopify.com',
  'soxn.myshopify.com',
  'lady-epis-shoppe.myshopify.com',
  '53cf89-2.myshopify.com',
  'island-supply-inc.myshopify.com',
  'diamondful.myshopify.com',
  'kojima-productions-online.myshopify.com',
  'cabinet-hardware-specialties.myshopify.com',
  'jewelerstradeshop.myshopify.com',
  'kpm-berlin.myshopify.com',
  'bhamadesigns.myshopify.com',
  'greenleafcrosby.myshopify.com',
  'diamond-home-furniture.myshopify.com',
  'monticello-store.myshopify.com',
  'fotile-store.myshopify.com',
  'kb-ottawa-plants.myshopify.com',
  'justartpotterydev.myshopify.com',
  'elle-rapha.myshopify.com',
  'fraktal-si.myshopify.com',
  'jolie-fete-belle.myshopify.com',
  'devaoe.myshopify.com',
  'rk-online2020.myshopify.com',
  'canvas-2pc.myshopify.com',
  'southern-drawl-store.myshopify.com',
  'petit-collage.myshopify.com',
  'flomotion-store.myshopify.com',
  'hevenbaby.myshopify.com',
  'lismore-jewel-centre.myshopify.com',
  'clint-orms-engravers-silversmiths.myshopify.com',
  'cultureathletics.myshopify.com',
  'rotweiss-b2c.myshopify.com',
  'lucent-glass-and-art.myshopify.com',
  'winesonlinenz.myshopify.com',
  'vice-press.myshopify.com',
  'hansel-stone-us.myshopify.com',
  'plastic-world-solutions.myshopify.com',
  'wilsonsportsme.myshopify.com',
  'xn-ehqu87b60u6ra.myshopify.com',
  'weconhome.myshopify.com',
  'thegowngalleria.myshopify.com',
  'grevers-winkel.myshopify.com',
  '421e3c-2.myshopify.com',
  'pet-script-texas.myshopify.com',
  'avicenna-scrubs.myshopify.com',
  'newsed-tokyo.myshopify.com',
  'bento-gaming-ca.myshopify.com',
  'jones-and-daughters.myshopify.com',
  'nigros-western-store-1.myshopify.com',
  'hodgepodgeentourage.myshopify.com',
  'uk-avon.myshopify.com',
  'oc-mounts.myshopify.com'
];

// List for stores WHITE GLOVE v3 v4 will change extra free and UPGRADE TO V5 (GMV)
export const WHITE_GLOVE_STORES = [
  {
    tenantId: 'bc-dev-v2-irene03.myshopify.com',
    csmName: 'Viktor',
    callLink: 'https://reviewsio.pipedrive.com/scheduler/jXK5rfLZ/meeting'
  },
  {
    tenantId: 'bc-dev-v2-josie21.myshopify.com',
    csmName: 'Carly',
    callLink: 'https://clearer.pipedrive.com/scheduler/mX59EfJk/meeting-default'
  },
  {
    tenantId: 'bc-dev-v2-quinn06.myshopify.com',
    csmName: 'Carly',
    callLink: 'https://clearer.pipedrive.com/scheduler/mX59EfJk/meeting-default'
  },
  {
    tenantId: 'mobelkompagniet-de.myshopify.com',
    csmName: 'Viktor',
    callLink: 'https://clearer.pipedrive.com/scheduler/jXK5rfLZ/meeting'
  },
  {
    tenantId: 'stpetersburg.myshopify.com',
    csmName: 'Carly',
    callLink: 'https://clearer.pipedrive.com/scheduler/mX59EfJk/meeting-default'
  },
  {
    tenantId: 'my-westside.myshopify.com',
    csmName: 'Nic',
    callLink: 'https://calendar.app.google/rQ5XgDASVaXkurwT9'
  },
  {
    tenantId: 'soccerpostb2b.myshopify.com',
    csmName: 'Carly',
    callLink: 'https://clearer.pipedrive.com/scheduler/mX59EfJk/meeting-default'
  },
  {
    tenantId: 'siphiphooray.myshopify.com',
    csmName: 'Carly',
    callLink: 'https://clearer.pipedrive.com/scheduler/mX59EfJk/meeting-default'
  },
  {
    tenantId: 'allsport-mu.myshopify.com',
    csmName: 'Viktor',
    callLink: 'https://clearer.pipedrive.com/scheduler/jXK5rfLZ/meeting'
  },
  {
    tenantId: 'moog-audio.myshopify.com',
    csmName: 'Carly',
    callLink: 'https://clearer.pipedrive.com/scheduler/mX59EfJk/meeting-default'
  },
  {
    tenantId: 'signaturefarmhouse.myshopify.com',
    csmName: 'Carly',
    callLink: 'https://clearer.pipedrive.com/scheduler/mX59EfJk/meeting-default'
  },

  {
    tenantId: 'danielkraftmann.myshopify.com',
    csmName: 'Carly',
    callLink: 'https://clearer.pipedrive.com/scheduler/mX59EfJk/meeting-default'
  },
  {
    tenantId: 'www-esafetysupplies-com.myshopify.com',
    csmName: 'Carly',
    callLink: 'https://clearer.pipedrive.com/scheduler/mX59EfJk/meeting-default'
  },
  {
    tenantId: 'damnfilters-com.myshopify.com',
    csmName: 'Carly',
    callLink: 'https://clearer.pipedrive.com/scheduler/mX59EfJk/meeting-default'
  },
  {
    tenantId: 'mxltst.myshopify.com',
    csmName: 'Carly',
    callLink: 'https://clearer.pipedrive.com/scheduler/mX59EfJk/meeting-default'
  },
  {
    tenantId: 'cookwoods.myshopify.com',
    csmName: 'Carly',
    callLink: 'https://clearer.pipedrive.com/scheduler/mX59EfJk/meeting-default'
  },
  {
    tenantId: 'wellbots-nyc.myshopify.com',
    csmName: 'Carly',
    callLink: 'https://clearer.pipedrive.com/scheduler/mX59EfJk/meeting-default'
  },
  {
    tenantId: 'svp-sports.myshopify.com',
    csmName: 'Carly',
    callLink: 'https://clearer.pipedrive.com/scheduler/mX59EfJk/meeting-default'
  },
  {
    tenantId: 'mobexpert.myshopify.com',
    csmName: 'Viktor',
    callLink: 'https://clearer.pipedrive.com/scheduler/jXK5rfLZ/meeting'
  },
  {
    tenantId: 'kingstonbrasstrade.myshopify.com',
    csmName: 'Carly',
    callLink: 'https://clearer.pipedrive.com/scheduler/mX59EfJk/meeting-default'
  },
  {
    tenantId: 'kingston-brass.myshopify.com',
    csmName: 'Carly',
    callLink: 'https://clearer.pipedrive.com/scheduler/mX59EfJk/meeting-default'
  },
  {
    tenantId: 'shop-petlifecentral.myshopify.com',
    csmName: 'Carly',
    callLink: 'https://clearer.pipedrive.com/scheduler/mX59EfJk/meeting-default'
  },
  {
    tenantId: 'pantsstore-telegraph.myshopify.com',
    csmName: 'Carly',
    callLink: 'https://clearer.pipedrive.com/scheduler/mX59EfJk/meeting-default'
  },
  {
    tenantId: 'anthony-ryans-galway.myshopify.com',
    csmName: 'Jonas',
    callLink: 'https://cal.eu/team/clearer/customer-success-call'
  },
  {
    tenantId: 'buildmatau.myshopify.com',
    csmName: 'Nic',
    callLink: 'https://calendar.app.google/rQ5XgDASVaXkurwT9'
  },
  {
    tenantId: 'okurashop.myshopify.com',
    csmName: 'Cindy',
    callLink: 'https://calendar.app.google/pTWFWHeWpByCKg5p7'
  },
  {
    tenantId: 'chrome-texas.myshopify.com',
    csmName: 'Carly',
    callLink: 'https://clearer.pipedrive.com/scheduler/mX59EfJk/meeting-default'
  },
  {
    tenantId: '58facettes.myshopify.com',
    csmName: 'Viktor',
    callLink: 'https://clearer.pipedrive.com/scheduler/jXK5rfLZ/meeting'
  },
  {
    tenantId: 'otaa.myshopify.com',
    csmName: 'Cindy',
    callLink: 'https://calendar.app.google/pTWFWHeWpByCKg5p7'
  },
  {
    tenantId: 'dugit-store.myshopify.com',
    csmName: 'Viktor',
    callLink: 'https://clearer.pipedrive.com/scheduler/jXK5rfLZ/meeting'
  },
  {
    tenantId: 'solsticesunglasses.myshopify.com',
    csmName: 'Carly',
    callLink: 'https://clearer.pipedrive.com/scheduler/mX59EfJk/meeting-default'
  },
  {
    tenantId: 'club21th.myshopify.com',
    csmName: 'Cindy',
    callLink: 'https://calendar.app.google/pTWFWHeWpByCKg5p7'
  },
  {
    tenantId: 'factory-direct-hobbies1.myshopify.com',
    csmName: 'Carly',
    callLink: 'https://clearer.pipedrive.com/scheduler/mX59EfJk/meeting-default'
  },
  {
    tenantId: 'spinriteonline.myshopify.com',
    csmName: 'Carly',
    callLink: 'https://clearer.pipedrive.com/scheduler/mX59EfJk/meeting-default'
  },
  {
    tenantId: 'gemma-by-wp-diamonds.myshopify.com',
    csmName: 'Carly',
    callLink: 'https://clearer.pipedrive.com/scheduler/mX59EfJk/meeting-default'
  },
  {
    tenantId: 'ico-uniforms.myshopify.com',
    csmName: 'Carly',
    callLink: 'https://clearer.pipedrive.com/scheduler/mX59EfJk/meeting-default'
  },
  {
    tenantId: 'ring-concierge.myshopify.com',
    csmName: 'Carly',
    callLink: 'https://clearer.pipedrive.com/scheduler/mX59EfJk/meeting-default'
  },
  {
    tenantId: 'choraltracks-com.myshopify.com',
    csmName: 'Carly',
    callLink: 'https://clearer.pipedrive.com/scheduler/mX59EfJk/meeting-default'
  },
  {
    tenantId: 'jordansoforegon.myshopify.com',
    csmName: 'Carly',
    callLink: 'https://clearer.pipedrive.com/scheduler/mX59EfJk/meeting-default'
  },
  {
    tenantId: 'stoneandtile.myshopify.com',
    csmName: 'Carly',
    callLink: 'https://clearer.pipedrive.com/scheduler/mX59EfJk/meeting-default'
  },
  {
    tenantId: 'oz-hair-beauty.myshopify.com',
    csmName: 'Nic',
    callLink: 'https://calendar.app.google/rQ5XgDASVaXkurwT9'
  },
  {
    tenantId: 'brandsdirectonline-com-au.myshopify.com',
    csmName: 'Cindy',
    callLink: 'https://calendar.app.google/pTWFWHeWpByCKg5p7'
  },
  {
    tenantId: 'designeroptics-com.myshopify.com',
    csmName: 'Carly',
    callLink: 'https://clearer.pipedrive.com/scheduler/mX59EfJk/meeting-default'
  },
  {
    tenantId: 'unionluminaires.myshopify.com',
    csmName: 'Carly',
    callLink: 'https://clearer.pipedrive.com/scheduler/mX59EfJk/meeting-default'
  },
  {
    tenantId: 'luoluo-style.myshopify.com',
    csmName: 'Carly',
    callLink: 'https://clearer.pipedrive.com/scheduler/mX59EfJk/meeting-default'
  }
];

export const WHITE_GLOVE_TENANT_IDS = WHITE_GLOVE_STORES.map(store => store.tenantId);

export const WHITE_GLOVE_SPECIAL_STORES = [
  {
    tenantId: 'bc-dev-v2-irene07.myshopify.com',
    csmName: 'Nic',
    callLink: 'https://calendar.app.google/rQ5XgDASVaXkurwT9'
  },
  {
    tenantId: 'stg-arcteryx.myshopify.com',
    csmName: 'Nic',
    callLink: 'https://calendar.app.google/rQ5XgDASVaXkurwT9'
  },
  {
    tenantId: 'darts-corner-germany.myshopify.com',
    csmName: 'Connor',
    callLink: 'https://calendar.app.google/vqcs4LcUkd2LR8xS7'
  },
  {
    tenantId: 'rogers-gardens.myshopify.com',
    csmName: 'Carly',
    callLink: 'https://clearer.pipedrive.com/scheduler/mX59EfJk/meeting-default'
  },
  {
    tenantId: 'star-school-supplies.myshopify.com',
    csmName: 'Viktor',
    callLink: 'https://clearer.pipedrive.com/scheduler/jXK5rfLZ/meeting'
  },
  {
    tenantId: 'atlanta-flooring-design-centers.myshopify.com',
    csmName: 'Carly',
    callLink: 'https://clearer.pipedrive.com/scheduler/mX59EfJk/meeting-default'
  },
  {
    tenantId: 'tailored-athlete-row-global-e-sandbox.myshopify.com',
    csmName: 'Connor',
    callLink: 'https://calendar.app.google/vqcs4LcUkd2LR8xS7'
  },
  {
    tenantId: 'rokit-uk-production.myshopify.com',
    csmName: 'Connor',
    callLink: 'https://calendar.app.google/vqcs4LcUkd2LR8xS7'
  },
  {
    tenantId: 'gagnonlgq.myshopify.com',
    csmName: 'Carly',
    callLink: 'https://clearer.pipedrive.com/scheduler/mX59EfJk/meeting-default'
  },
  {
    tenantId: 'soyaconcept-nl.myshopify.com',
    csmName: 'Viktor',
    callLink: 'https://clearer.pipedrive.com/scheduler/jXK5rfLZ/meeting'
  },
  {
    tenantId: 'pre-order-center.myshopify.com',
    csmName: 'Carly',
    callLink: 'https://clearer.pipedrive.com/scheduler/mX59EfJk/meeting-default'
  },
  {
    tenantId: 'partsource.myshopify.com',
    csmName: 'Carly',
    callLink: 'https://clearer.pipedrive.com/scheduler/mX59EfJk/meeting-default'
  },
  {
    tenantId: 'amiclubwearstore.myshopify.com',
    csmName: 'Carly',
    callLink: 'https://clearer.pipedrive.com/scheduler/mX59EfJk/meeting-default'
  },
  {
    tenantId: 'eu-wanan.myshopify.com',
    csmName: 'Viktor',
    callLink: 'https://clearer.pipedrive.com/scheduler/jXK5rfLZ/meeting'
  },
  {
    tenantId: 'erniessports.myshopify.com',
    csmName: 'Carly',
    callLink: 'https://clearer.pipedrive.com/scheduler/mX59EfJk/meeting-default'
  },
  {
    tenantId: 'adasa-2.myshopify.com',
    csmName: 'Carly',
    callLink: 'https://clearer.pipedrive.com/scheduler/mX59EfJk/meeting-default'
  },
  {
    tenantId: 'boathousestores-usa.myshopify.com',
    csmName: 'Carly',
    callLink: 'https://clearer.pipedrive.com/scheduler/mX59EfJk/meeting-default'
  },
  {
    tenantId: 'lenmarkindustries.myshopify.com',
    csmName: 'Carly',
    callLink: 'https://clearer.pipedrive.com/scheduler/mX59EfJk/meeting-default'
  },
  {
    tenantId: 'beadaholique.myshopify.com',
    csmName: 'Carly',
    callLink: 'https://clearer.pipedrive.com/scheduler/mX59EfJk/meeting-default'
  },
  {
    tenantId: 'metrohobbies.myshopify.com',
    csmName: 'Nic',
    callLink: 'https://calendar.app.google/rQ5XgDASVaXkurwT9'
  },
  {
    tenantId: 'speedscience.myshopify.com',
    csmName: 'Nic',
    callLink: 'https://calendar.app.google/rQ5XgDASVaXkurwT9'
  },
  {
    tenantId: 'alloy-wheel-shop.myshopify.com',
    csmName: 'Connor',
    callLink: 'https://calendar.app.google/vqcs4LcUkd2LR8xS7'
  },
  {
    tenantId: 'power-motion-industrial-supplies-inc.myshopify.com',
    csmName: 'Carly',
    callLink: 'https://clearer.pipedrive.com/scheduler/mX59EfJk/meeting-default'
  },
  {
    tenantId: 'inlinetubedealers.myshopify.com',
    csmName: 'Carly',
    callLink: 'https://clearer.pipedrive.com/scheduler/mX59EfJk/meeting-default'
  },
  {
    tenantId: 'flexteknik-se.myshopify.com',
    csmName: 'Viktor',
    callLink: 'https://clearer.pipedrive.com/scheduler/jXK5rfLZ/meeting'
  },
  {
    tenantId: 'ecommerceworld1.myshopify.com',
    csmName: 'Carly',
    callLink: 'https://clearer.pipedrive.com/scheduler/mX59EfJk/meeting-default'
  },
  {
    tenantId: 'kindal-online24.myshopify.com',
    csmName: 'Nic',
    callLink: 'https://calendar.app.google/rQ5XgDASVaXkurwT9'
  },
  {
    tenantId: 'mph-online.myshopify.com',
    csmName: 'Nic',
    callLink: 'https://calendar.app.google/rQ5XgDASVaXkurwT9'
  }
];

export const WHITE_GLOVE_SPECIAL_TENANT_IDS = WHITE_GLOVE_SPECIAL_STORES.map(
  store => store.tenantId
);

// List for stores v3 v4 will change extra free BUT NOT UPGRADE TO V5 (GMV)
export const GENERAL_SPECIAL_PRICING_CHANGE_STORE = [
  'bc-dev-v2-irene06.myshopify.com',
  'bc-dev-v2-irene14.myshopify.com',
  'bc-dev-v2-josie25.myshopify.com',
  'bc-dev-v2-irene25.myshopify.com',
  'spiritly-trade-ire.myshopify.com',
  'vodaland-test.myshopify.com',
  'oldach-trading-prod.myshopify.com',
  'thearchivexyana.myshopify.com',
  'mmibt2-8r.myshopify.com',
  'premier-darts-deutschland.myshopify.com',
  'lauremat.myshopify.com',
  'ppwholesaleuk.myshopify.com',
  'vpk6di-qq.myshopify.com',
  'm-p-bullseye.myshopify.com',
  'bmj285-bh.myshopify.com',
  'strapyatest.myshopify.com',
  'spiritlyus.myshopify.com',
  'mmvvg4-r4.myshopify.com',
  'woven-official.myshopify.com',
  'zuty-romania.myshopify.com',
  'tyaani-com.myshopify.com',
  'that-truck-and-van.myshopify.com',
  'art-of-time-online.myshopify.com',
  'biker-jewelry-shop.myshopify.com',
  'havasu.myshopify.com',
  'diamondi-ro.myshopify.com',
  'sodkova.myshopify.com',
  'sorry-state-test-site.myshopify.com',
  'bench-costco-next.myshopify.com',
  'specialorder-abccork-com.myshopify.com',
  'etiql-stage.myshopify.com',
  'gempawn.myshopify.com',
  'zeboose.myshopify.com',
  'castlemaine-office-supplies-1.myshopify.com',
  'nature-wood-floors.myshopify.com',
  'jingo-clothing.myshopify.com',
  'koopresale.myshopify.com',
  'alpecin-au.myshopify.com',
  'ecowoodrings.myshopify.com',
  'thebedlinenco.myshopify.com',
  'dev-tiptop.myshopify.com',
  'suspire-in.myshopify.com',
  'tahoe-mountain-sports.myshopify.com',
  'mediahoek.myshopify.com',
  'golf-clubs-com.myshopify.com',
  'canopy-floors.myshopify.com',
  'altura-stone-tile.myshopify.com',
  'the-thrifty-stork.myshopify.com',
  'levis4floors.myshopify.com',
  'jp-flooring-1.myshopify.com',
  'easytatt-ink-uk.myshopify.com',
  'pp-mhaps.myshopify.com',
  'xspares.myshopify.com',
  'global-orient-star-stg-environment.myshopify.com',
  'earthwerks.myshopify.com',
  'shop-for-shelter.myshopify.com',
  'love-co-malaysia.myshopify.com',
  'plywell-cabinetry.myshopify.com',
  'pittman-usa.myshopify.com',
  'ellifox.myshopify.com',
  'boardcollective.myshopify.com',
  'planetabeneficioscl.myshopify.com',
  'ziddy-ksa.myshopify.com',
  'pittman-germany.myshopify.com',
  'insania-mania.myshopify.com',
  'materiauxjls.myshopify.com',
  'leejeansth.myshopify.com',
  'arthur-schofield.myshopify.com',
  'flatiron-nyc-di.myshopify.com',
  'burg-waechter.myshopify.com',
  'd5a0da.myshopify.com',
  'a1182e-5.myshopify.com',
  'glentel-gwe.myshopify.com',
  'preownedweddingdresses.myshopify.com',
  'mycareshopnz.myshopify.com',
  'flooringstores.myshopify.com',
  'americas-floor-source.myshopify.com',
  'warm-nordic.myshopify.com',
  'maje-uae-pre-prod.myshopify.com',
  'maliekids-shop.myshopify.com',
  'the-inkey-list-aus.myshopify.com',
  'rf-creative.myshopify.com',
  'sweetsvillage.myshopify.com',
  'go-sport-ksa.myshopify.com',
  'just-golf-stuff-us.myshopify.com',
  'balharbourshops.myshopify.com',
  'mac-designs-jewelry.myshopify.com',
  'gcwine.myshopify.com',
  'isenkraem.myshopify.com',
  'suminoe-contract.myshopify.com',
  'wild-on-the-fly.myshopify.com',
  'suminoe.myshopify.com',
  'trade-bm.myshopify.com',
  'bcprofiles.myshopify.com',
  'yz-pr.myshopify.com',
  'diamondi-de.myshopify.com',
  'zuty-bulgaria.myshopify.com',
  'thollot-jewelers.myshopify.com',
  'souris-mini-marketplace.myshopify.com',
  'secondklick.myshopify.com',
  'premium-lounge-ny.myshopify.com',
  'lekker-snoozen.myshopify.com',
  'beyondknots.myshopify.com',
  'areabeige.myshopify.com',
  'retykle-singapore.myshopify.com',
  'uknails.myshopify.com',
  'modern-desi-llc.myshopify.com',
  'fryguypins.myshopify.com',
  'genemco.myshopify.com',
  'us-kendamil-com.myshopify.com',
  'whitestone-dev.myshopify.com',
  'dipndive.myshopify.com',
  'kingstonbrassoutlet.myshopify.com',
  'andres-wireless-accessories.myshopify.com',
  'roadcases-co-nz.myshopify.com',
  'swixsport.myshopify.com',
  'caratia.myshopify.com',
  'elia-bathrooms.myshopify.com',
  'sleek-nail.myshopify.com',
  'wranglerth.myshopify.com',
  'tupperware-my-em.myshopify.com',
  'antonia-pia-gordon-uae.myshopify.com',
  'silva-sweden-ca.myshopify.com',
  'moogoo-malaysia.myshopify.com',
  'moogoo-canada.myshopify.com',
  'uabsign.myshopify.com',
  'invisalign-store-es.myshopify.com',
  'collegepress-zw.myshopify.com',
  'tcwc-internaldevelopment.myshopify.com',
  'mac-botswana.myshopify.com',
  'acalin-webshop.myshopify.com',
  'fddf54.myshopify.com',
  'house-of-bimbi.myshopify.com',
  'gelcare-pro-lounge.myshopify.com',
  'bb9275.myshopify.com',
  'stephensjewellers.myshopify.com',
  'wasabi-dk.myshopify.com',
  'divani-store-b2b.myshopify.com',
  'twillory-test-return-exchange.myshopify.com',
  'rhino-greenhouses-usa.myshopify.com',
  'tech-to-school.myshopify.com',
  'gigate-ksa.myshopify.com',
  'uglyfoodco.myshopify.com',
  'kennedys-showcase.myshopify.com',
  'tier1business.myshopify.com',
  'langerman-diamonds.myshopify.com',
  'planetabeneficiosar.myshopify.com',
  'ibp-power-solutions.myshopify.com',
  'proj3ct-store.myshopify.com',
  'www-myvisionsurplus-com.myshopify.com',
  'leveteroom.myshopify.com',
  'mythic-cardz-9893.myshopify.com',
  'all-systems-go-games.myshopify.com',
  'westinghousehome.myshopify.com',
  'uat-calif.myshopify.com',
  'pid-floors.myshopify.com',
  'mayoreototal.myshopify.com',
  'bestfriendsconsignment.myshopify.com',
  '89f4a7.myshopify.com',
  'daladecor.myshopify.com',
  'public-desire-usa.myshopify.com',
  'public-desire-au.myshopify.com',
  'public-desire-eu.myshopify.com',
  'gibsons-us.myshopify.com',
  'ajeebps.myshopify.com',
  'tender-essentials.myshopify.com',
  'meermin-seconds.myshopify.com',
  'lettherecordsplay.myshopify.com',
  'megastore-abbigliamento.myshopify.com',
  'vanguardworld-es.myshopify.com',
  'pgmartworld.myshopify.com',
  'found-rental-co.myshopify.com',
  'cygnettph.myshopify.com',
  'rokkogromantik.myshopify.com',
  'thegemflystore.myshopify.com',
  'sportcouturero.myshopify.com',
  'mehraban-rugs.myshopify.com',
  'closet-exchange-store.myshopify.com',
  'procaravan.myshopify.com',
  'monicaandandy-broadwayplaza.myshopify.com',
  'earthiemodern.myshopify.com',
  'b2b-australia.myshopify.com',
  'tiles-together-pty-ltd.myshopify.com',
  'edisastersystems.myshopify.com',
  'luxuryloungeatl.myshopify.com',
  'prosser-co.myshopify.com',
  'la-vie-en-rose-hq-core-site.myshopify.com',
  'liquornearme.myshopify.com',
  '1vmupy-zi.myshopify.com',
  'naak-re.myshopify.com',
  'torgeis.myshopify.com',
  'castoreaus.myshopify.com',
  'tiarapets.myshopify.com',
  'visique-production.myshopify.com',
  'arctix1.myshopify.com',
  'lee-volk-jewellers.myshopify.com',
  'domestic-spare-parts.myshopify.com',
  'moovkart.myshopify.com',
  'melcou-fabrics.myshopify.com',
  'samifinejewelry.myshopify.com',
  'epochlax.myshopify.com',
  '973e35-3.myshopify.com',
  'urban-species-retail.myshopify.com',
  'ilovemylife.myshopify.com',
  'fakeeh-vision.myshopify.com',
  'stg-daiwa-cycle.myshopify.com',
  'johnnys-furniture-1.myshopify.com',
  'ballantynes-jewellers.myshopify.com',
  'celestron-employee-store.myshopify.com',
  'a5a668.myshopify.com',
  'simplyfashion-no.myshopify.com',
  'ichika-wasou.myshopify.com',
  'kah-online.myshopify.com',
  'offe-jewellers.myshopify.com',
  'voda-boutique.myshopify.com',
  'gingerblue.myshopify.com',
  'cncsuppysolutions.myshopify.com',
  'americansunglass-com.myshopify.com',
  '27515b-2.myshopify.com',
  'ed-perkin-dubai-portal.myshopify.com',
  'omax-microscope.myshopify.com',
  'hankoya-store.myshopify.com',
  'shopnyra.myshopify.com',
  'naak-au.myshopify.com',
  'vintage-foundry-co.myshopify.com',
  'the-gtc.myshopify.com',
  'treasurefinejeweler.myshopify.com',
  'worldwide-floors.myshopify.com',
  'dearavajewelry.myshopify.com',
  'apricus-art-collection.myshopify.com',
  'vitaloutdoors-golden.myshopify.com',
  'c4d561-6d.myshopify.com',
  'horn-garment-official.myshopify.com',
  'boat-rv-accessories.myshopify.com',
  'kayla-diamonds.myshopify.com',
  'stash-tea-canada.myshopify.com',
  'chope-bali.myshopify.com',
  'wynberg-lights.myshopify.com',
  'dfa66a-3.myshopify.com',
  'd8a123.myshopify.com',
  'mightyjaxx-wholesale-uk.myshopify.com',
  'venatio-flyttbar.myshopify.com',
  'mightyjaxx-wholesale-eu.myshopify.com',
  'ninety5sport.myshopify.com',
  'westside-den-bosch.myshopify.com',
  'twgtea.myshopify.com',
  'helix-sounds.myshopify.com',
  'shoprecordstore.myshopify.com',
  'quality-laser-supply.myshopify.com',
  'skullvikings.myshopify.com',
  'sport-vl-2-0.myshopify.com',
  'lcitest1.myshopify.com',
  'beatlas.myshopify.com',
  'decor-uk-prod.myshopify.com',
  'tolly-toys.myshopify.com',
  'gamilarugs.myshopify.com',
  'e-auto-inc.myshopify.com',
  'lanhams-jewellers-griffith.myshopify.com',
  'pettits-jewellers.myshopify.com',
  'lijodecor.myshopify.com',
  'escentials-vn.myshopify.com',
  'evisu-tw.myshopify.com',
  'evisu-sa.myshopify.com',
  'evisu-ap.myshopify.com',
  'boutiqueboys.myshopify.com',
  'singer-europe.myshopify.com',
  'gund-dtc-staging.myshopify.com',
  'singer-uk.myshopify.com',
  'nantucket-looms-development.myshopify.com',
  'singer-mexico.myshopify.com',
  'kadia-jewellery.myshopify.com',
  'thekundanshop.myshopify.com',
  'newyorkdress-store.myshopify.com',
  'sziro-jewelry.myshopify.com',
  'prettymomentdress.myshopify.com',
  '730558-2.myshopify.com',
  'wineroo.myshopify.com',
  'regencyjewellers.myshopify.com',
  'naak-za.myshopify.com',
  'costumeboom.myshopify.com',
  'camellia-bridal-shop.myshopify.com',
  'evisu-hk-staging.myshopify.com',
  'piagonal.myshopify.com',
  'sm-ca-shop.myshopify.com',
  'blackwellshoes.myshopify.com',
  'messy-meg.myshopify.com',
  'shopwildwings.myshopify.com',
  'artisan-co-op.myshopify.com',
  'christophersfinejewelry.myshopify.com',
  'aspire-jewels-swan-hill.myshopify.com',
  'boutique-designers.myshopify.com',
  'karington-jewellery.myshopify.com',
  'peoplejeans.myshopify.com',
  '0riginalfeet.myshopify.com',
  'clarapucci.myshopify.com',
  'ram-mount-flyttbar.myshopify.com',
  'james-showroom.myshopify.com',
  'llw-contract.myshopify.com',
  'reuplane.myshopify.com',
  'wellforces-llc.myshopify.com',
  'jewellers-port-lincoln.myshopify.com',
  'beautydeals-com.myshopify.com',
  'foster-co-jewellery.myshopify.com',
  '274095.myshopify.com',
  '9c8c79.myshopify.com',
  'us-alterraretail.myshopify.com',
  'blinktrends-com-4.myshopify.com',
  'icebergatboulevard.myshopify.com',
  'actionclutch-me.myshopify.com',
  'nixonsafety.myshopify.com',
  'fiveseasonoptical.myshopify.com',
  'b2b2bpilot.myshopify.com',
  'everly-jewellers-ijc.myshopify.com',
  'le-jewellery-13.myshopify.com',
  'applausellc.myshopify.com',
  'lumicentropanama.myshopify.com',
  'wellforces.myshopify.com',
  '6e259f.myshopify.com',
  'whiteriver-mouldings.myshopify.com',
  'yankeekicks-store.myshopify.com',
  'apex-gift.myshopify.com',
  'english-tealeaves-cafe.myshopify.com',
  'asocincnordics.myshopify.com',
  'toad-co-golden.myshopify.com',
  'thomas-kinkade-studios-wholesale.myshopify.com',
  'simple-sample-australia.myshopify.com',
  'more-loop.myshopify.com',
  'medicinemangallery.myshopify.com',
  'fenvy.myshopify.com'
];

export const SPECIAL_PRICING_CHANGE_STORES = [
  ...GENERAL_SPECIAL_PRICING_CHANGE_STORE,
  ...WHITE_GLOVE_SPECIAL_TENANT_IDS
];

export const ALL_WHITE_GLOVE_STORES = [...WHITE_GLOVE_STORES, ...WHITE_GLOVE_SPECIAL_STORES];
